import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { useGetClienteColoresMutation } from '../../../../store/api/endpoints/clientesApiSlice'

import { openFeedback } from '../../../../store/slices/feedback'
import { getUsuarioPermisos } from '../../../../store/slices/auth'

import Loading from '../../../elementos/Loading'
import DisplayInfoUl from '../../../elementos/DisplayInfoUl'

export default function ClienteColoresGet() {

    const urlParams = useParams()
    const dispatch = useDispatch()

    const permisosDelUsuario = useSelector(getUsuarioPermisos)

    const [
        getRegistro,
        {
            data: responseGetRegistro,
            isUninitialized: isUninitializedGetRegistro,
            isLoading: isLoadingGetRegistro,
            isSuccess: isSuccessGetRegistro,
            isError: isErrorGetRegistro,
            error: errorDataGetRegistro,
        }
    ] = useGetClienteColoresMutation()

    useEffect(() => {
        getRegistro(urlParams.id)
    }, [])

    useEffect(() => {
        if (isErrorGetRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataGetRegistro.data.message
            }))
        }
    }, [isErrorGetRegistro])

    if (permisosDelUsuario.indexOf(3) == -1) return (<p>No tienes acceso a visualizar los clientes.</p>)

    if (isUninitializedGetRegistro || isLoadingGetRegistro) return (<Loading />)

    return (<>
        <DisplayInfoUl
            titulo="Colores"
            editar={(permisosDelUsuario.indexOf(9) != -1 ? {
                path: '/clientes/' + urlParams.id + '/edit/colores'
            } : '')}
            data={
                [
                    { index: 'Menu', value: responseGetRegistro.menu },
                    { index: 'Menu Texto', value: responseGetRegistro.menu_texto },
                    { index: 'Botones', value: responseGetRegistro.botones },
                    { index: 'Botones Texto', value: responseGetRegistro.botones_texto },
                    { index: 'Footer', value: responseGetRegistro.footer },
                    { index: 'Footer Texto', value: responseGetRegistro.footer_texto },
                    { index: 'Fondo', value: responseGetRegistro.fondo },
                    { index: 'Fondo Texto', value: responseGetRegistro.fondo_texto },
                    { index: 'Lista', value: responseGetRegistro.lista },
                    { index: 'Lista Texto', value: responseGetRegistro.lista_texto },
                ]
            }
        />
    </>)

}

